import React, { FC } from 'react';
import ValueWithLabel from '../../../customiseContainer/footer/PriceSection/CarPrices/percentageWithLabel/ValueWithLabel';
import { Grid } from '@material-ui/core';
import rateStyles from './rateStyles';
import Translation from '../../../../../common/components/translation/Translation';

export interface IRateProps {
  labelId: string;
  value: string | JSX.Element;
  indicativeNumber?: JSX.Element;
}

const Rate: FC<IRateProps> = ({ labelId, value, indicativeNumber }) => {
  const styles = rateStyles();

  return (
    <Grid item={true} md="auto" xs={4} className={styles.rateContainer} key={labelId}>
      <ValueWithLabel
        data-test={`finance_values:${labelId}`}
        value={value}
        valueType={labelId}
        label={
          <>
            <Translation id={`spc.customise.footer.finance.${labelId}`} />
            {indicativeNumber ?? null}
          </>
        }
      />
    </Grid>
  );
};

export default Rate;
